var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_322_2820",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_322_2820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 21.1875V15.5625C14.1562 14.0092 15.4155 12.75 16.9688 12.75C18.522 12.75 19.7812 14.0092 19.7812 15.5625V21.1875",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 24C26.6655 24 25.4062 22.7408 25.4062 21.1875V15.5625C25.4062 14.0092 26.6655 12.75 28.2188 12.75C29.772 12.75 31.0312 14.0092 31.0312 15.5625V21.1875C31.0312 22.7408 29.772 24 28.2188 24Z",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8438 24C32.2905 24 31.0312 22.7408 31.0312 21.1875V18.375C31.0312 16.8217 32.2905 15.5625 33.8438 15.5625C35.397 15.5625 36.6562 16.8217 36.6562 18.375V21.1875C36.6562 22.7408 35.397 24 33.8438 24Z",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 21.1875C25.4062 22.7408 24.147 24 22.5938 24",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 21.1875V15.5625C19.7812 14.0092 21.0405 12.75 22.5938 12.75C24.147 12.75 25.4062 14.0092 25.4062 15.5625",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 26.8125V24C11.3438 22.4467 12.603 21.1875 14.1562 21.1875H19.7812C21.3345 21.1875 22.5938 22.4467 22.5938 24C22.5938 25.5533 21.3345 26.8125 19.7812 26.8125H16.9688C20.0753 26.8125 22.5938 29.3309 22.5938 32.4375",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6562 21.1875V28.2188C36.6562 35.25 32.4375 38.0625 32.4375 38.0625H16.9688C16.9688 38.0625 11.3438 35.25 11.3438 28.2188V26.8125",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4375 38.0625V46.5938H16.9688V38.0625",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 26.8125H16.9688",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4.54485e-07V5.71875",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24H5.71875",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2812 24H48",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0957 7.0958L11.0731 11.0732",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9268 11.0732L40.9043 7.0958",
    stroke: "#002222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.8cf562d2ede754765a7b15557796b71d.svg";
export { ForwardRef as ReactComponent };